import 'react-phone-input-2/lib/style.css'

import { parsePhoneNumberFromString } from 'libphonenumber-js'
import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import PhoneInput from 'react-phone-input-2'

import useForm from '../../../../hooks/useForm'
import ConfirmationDialog from '../../ConfirmationDialog/index'
import Input from '../../Input/index'
import { ReactComponent as InfoIcon } from './info.svg'
import styles from './MessagingSetupDialog.module.scss'

const MessagingSetupDialog = ({
  guestFirstName = '',
  guestLastName = '',
  phoneNumber = '+1',
  roomNumber = 'N/A',
  handleConfirm,
  handleCancel
}) => {
  const [guestPhoneCountryCode, setGuestPhoneCountryCode] = useState()
  const [guestPhoneNumber, setGuestPhoneNumber] = useState()

  useEffect(() => {
    const parsedNumber =
      typeof phoneNumber === 'string' && parsePhoneNumberFromString(phoneNumber)

    if (parsedNumber) {
      const { countryCallingCode, nationalNumber } = parsedNumber

      setGuestPhoneNumber(nationalNumber)
      setGuestPhoneCountryCode(countryCallingCode)
    }
  }, [phoneNumber])

  const [values, setValues, setValue] = useForm({
    guestFirstName,
    guestLastName,
    phoneNumber,
    roomNumber
  })

  const [isFormValidated, setFormValidated] = useState(false)

  const phoneLabelRef = useRef()

  useEffect(() => {
    if (
      phoneLabelRef.current &&
      phoneLabelRef.current.querySelector('input') &&
      process.env.JEST_WORKER_ID === undefined
    ) {
      phoneLabelRef.current.querySelector('input').focus()
    }
  }, [phoneLabelRef])

  useEffect(() => {
    const firstNamePass = values.guestFirstName && values.guestFirstName.length > 1
    const lastNamePass = values.guestLastName && values.guestLastName.length > 1
    const phoneNumberPass =
      values.phoneNumber && values.phoneNumber.replace(/[^0-9]+/g, '').length > 6
    const roomNumberPass = values.roomNumber && values.roomNumber.length > 1

    if (firstNamePass && lastNamePass && phoneNumberPass && roomNumberPass) {
      setFormValidated(true)
    } else {
      setFormValidated(false)
    }
  }, [values.guestFirstName, values.guestLastName, values.phoneNumber, values.roomNumber])

  function handleChangePhone(phoneNumber) {
    setValue({ phoneNumber })

    const parsedNumber =
      typeof phoneNumber === 'string' && parsePhoneNumberFromString(phoneNumber)

    if (parsedNumber) {
      const { countryCallingCode, nationalNumber } = parsedNumber
      setGuestPhoneCountryCode(countryCallingCode)
      setGuestPhoneNumber(nationalNumber)
    }
  }

  return (
    <ConfirmationDialog
      positiveMessage="Start chat"
      negativeMessage="Cancel"
      onConfirm={() =>
        handleConfirm({
          guestFirstName: values.guestFirstName,
          guestLastName: values.guestLastName,
          roomNumber: values.roomNumber,
          guestPhoneNumber: guestPhoneNumber || values.phoneNumber,
          guestPhoneCountryCode: guestPhoneCountryCode || '1'
        })
      }
      onClose={handleCancel}
      isButtonDisabled={!isFormValidated}
      title="Set up messaging"
      hasFixedTopMargin={true}
    >
      <div className={styles.container}>
        <div className={styles.bar}>
          <>
            <InfoIcon />
            Guest will get a welcome text after enabling
          </>
        </div>
        <div className={styles.phoneLabelContainer}>
          <label className={styles.phoneLabel} ref={phoneLabelRef}>
            <span className={styles.labelInner}>Cell phone number</span>
            <PhoneInput
              inputExtraProps={{ autoComplete: 'off' }}
              defaultCountry="US"
              onChange={handleChangePhone}
              value={values.phoneNumber || '+1'}
            />
          </label>
        </div>
        <div className={styles.nameInputs}>
          <Input
            autoComplete="disabled"
            label="First name"
            name="guestFirstName"
            handleChange={setValues}
            value={values.guestFirstName}
          />
          <Input
            autoComplete="disabled"
            label="Last name"
            name="guestLastName"
            handleChange={setValues}
            value={values.guestLastName}
          />
        </div>
      </div>
    </ConfirmationDialog>
  )
}

MessagingSetupDialog.propTypes = {
  didMessagingStarted: PropTypes.bool,
  isGroupBooking: PropTypes.bool,
  clientFullName: PropTypes.string,
  guestFirstName: PropTypes.string,
  guestLastName: PropTypes.string,
  phoneNumber: PropTypes.string,
  roomNumber: PropTypes.string,
  handleConfirm: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired
}

export default MessagingSetupDialog
